import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IPaymentInfo } from '@dch/billing-business-logic';
import { EntityManager } from '@dch/entity-manager';
import { of } from 'rxjs';
import {
  map,
  catchError,
  withLatestFrom,
  switchMap,
  mergeMap,
} from 'rxjs/operators';
import { PAYMENT_INFO_ENTITY } from 'src/app/my-bill/config/my-bill-entity.config';
import {
  getBillingPaymentInfoFailure,
  getBillingPaymentInfoRequest,
  getBillingPaymentInfoSuccess,
} from '../actions/billing-payment-info.actions';

import { ApplicationState } from '../reducers';
import { selectCustomer } from '../selectors/customer-account.selector';

@Injectable()
export class BillingPaymentInfoEffects {
  getBillingPaymentInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getBillingPaymentInfoRequest),
      map(({ billingAccountNumber }) => billingAccountNumber),
      withLatestFrom(this.store.select(selectCustomer)),
      mergeMap(([billingAccountNumber, customer]) =>
        EntityManager.getEntity<IPaymentInfo>(PAYMENT_INFO_ENTITY, {
          cdbId: customer.customerId,
          billingAccountNumber,
        }).pipe(
          map((entity) =>
            entity.value
              ? getBillingPaymentInfoSuccess({
                  billingAccountNumber,
                  paymentInfo: entity.value,
                })
              : getBillingPaymentInfoFailure({ billingAccountNumber })
          ),
          catchError(() =>
            of(getBillingPaymentInfoFailure({ billingAccountNumber }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<ApplicationState>
  ) {}
}
